<template>
  <ul class="activity-result__stack-list">
    <daily-work-stack-list-item
      v-for="date in dateListInSelectedMonth"
      :key="formatYYYYMMDD(date)"
      :date="date"
      :daily-work-list="dailyWorkListByCreatedDt[formatYYYYMMDD(date)]"
      :selected="isSelectedDate(date)" />
  </ul>
</template>

<script>
import groupBy from 'lodash/groupBy'
import format from 'date-fns/format'
import DailyWorkStackListItem from '@/components/view/DailyWorkStackListItem.vue'
import getDaysInMonth from 'date-fns/getDaysInMonth'
import addDays from 'date-fns/addDays'
import startOfMonth from 'date-fns/startOfMonth'
import isSameDay from 'date-fns/isSameDay'
import range from 'lodash/range'
export default {
  components: {
    DailyWorkStackListItem
  },
  props: {
    selectedDate: {
      type: Date,
      required: true
    },
    dailyWorkList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dailyWorkListByCreatedDt() {
      return groupBy(this.dailyWorkList, this.formatDailyWorkCreatedDt)
    },
    startDateOfMonth() {
      return startOfMonth(this.selectedDate)
    },
    dateListInSelectedMonth() {
      return range(0, getDaysInMonth(this.selectedDate)).map(n => addDays(this.startDateOfMonth, n))
    }
  },
  methods: {
    formatYYYYMMDD(date) {
      return format(new Date(date), 'yyyy-MM-dd')
    },
    formatDailyWorkCreatedDt(dailyWork) {
      return this.formatYYYYMMDD(dailyWork.createdDt)
    },
    isSelectedDate(date) {
      return isSameDay(this.selectedDate, date)
    }

  }

}
</script>

<style lang="scss" scoped>
.activity-result__stack-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0;
}
</style>